var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.path != '/' && _vm.$route.path != '/forgetpassword' && _vm.$route.name != 'resetpassword'&& _vm.$route.name != 'Registation')?_c('Navbar'):_vm._e(),_c('v-main',{staticStyle:{"background-color":"#f0f0f7"}},[_c('router-view',{attrs:{"CountryList":_vm.CountryList,"CountrySizeList":_vm.CountrySizeList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }